import { motion } from 'framer-motion';
import styled from 'styled-components';

import { CommentWrapper } from '../Comment/styled';

export const CommentThreadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CommentThreadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

interface CommentThreadContainerParentMessageContainerProps {
  replying: boolean;
}

export const CommentThreadContainerParentMessageContainer = styled.div<CommentThreadContainerParentMessageContainerProps>`
  ${({ replying }) =>
    replying &&
    `
    ${CommentWrapper} {
      border-radius: 16px 16px 0px 16px;
    }
  `}
`;

interface CommentThreadReplyContainerProps {
  lastOne: boolean;
  firstOne: boolean;
}

export const CommentThreadReplyContainer = styled(motion.div).attrs({
  initial: { height: 0, overflow: 'hidden' },
  animate: { height: 'auto', overflow: 'unset' },
  exit: { height: 0, overflow: 'hidden' },
})<CommentThreadReplyContainerProps>`
  display: flex;
  flex-direction: row;
  gap: 6px;

  ${CommentWrapper} {
    border-radius: ${({ lastOne }) => (lastOne ? '0px 0px 16px 16px' : '0px')};
    ${({ firstOne, lastOne }) => {
      if (firstOne && lastOne) return `border-top: unset;`;
      if (firstOne && !lastOne) return `border-top: unset; border-bottom: unset;`;
      if (!firstOne && !lastOne) return `border-bottom: unset;`;
      if (!firstOne && lastOne) return ``;

      return 'border-top: unset; border-bottom: unset;';
    }}
  }

  [data-id='comment-reply-icon'],
  [data-id='comment-reply-button'] {
    display: none;
  }
`;

export const CommentThreadReplyLineContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding-left: 16px;
`;

interface CommentThreadReplyLineProps {
  straight?: boolean;
}

export const CommentThreadReplyLine = styled.div<CommentThreadReplyLineProps>`
  width: 15px;
  border-left: 1px solid rgba(23, 28, 51, 0.1);

  height: 50%;

  ${({ straight = false }) =>
    !straight &&
    `
    border-bottom: 1px solid rgba(23, 28, 51, 0.1);
  `}
`;

interface CommentThreadInputContainerProps {
  hasReply: boolean;
}

export const CommentThreadInputContainer = styled(motion.div).attrs({
  initial: { height: 0, padding: '0px 16px' },
  animate: { height: 'auto', padding: '16px 16px' },
  exit: { height: 0, padding: '0px 16px' },
})<CommentThreadInputContainerProps>`
  display: flex;
  flex-direction: column;

  margin-left: 48px;

  overflow: hidden;
`;
